import React, {useRef, useEffect} from 'react';
import {useRouter} from 'next/router';

const CertAwardSection = ({aboutus}) => {
    const {locale} = useRouter();
    const values = aboutus?.WEB_ABOUT_CERT_AWARDS?.value || {};
    const items = values?.array_images || [];

    const scrollRef = useRef(null);
    const intervalRef = useRef(null);

    useEffect(() => {
        const el = scrollRef.current;
        if (!el) return;

        let direction = 1;

        const step = () => {
            el.scrollLeft += direction * 1.5;

            if (el.scrollLeft + el.clientWidth >= el.scrollWidth - 1) {
                direction = -1;
            } else if (el.scrollLeft <= 0) {
                direction = 1;
            }
        };

        const interval = setInterval(step, 16); // ~60fps

        const handleResize = () => {
            // có thể reset scroll hoặc thay đổi logic nếu cần
            console.log('Resize detected, scrollWidth:', el.scrollWidth, 'clientWidth:', el.clientWidth);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            clearInterval(interval);
            window.removeEventListener('resize', handleResize);
        };
    }, [items.length]);

    /* =====================
       TITLE (VI / EN)
    ===================== */
    const title = locale === 'en' ? values?.title_en || '' : values?.title || '';

    const words = title.trim().split(/\s+/);
    const firstTwo = words.slice(0, 2).join(' ');
    const rest = words.slice(2).join(' ');

    /* =====================
       DESCRIPTION (VI / EN)
    ===================== */
    const description = locale === 'en' ? values?.short_description_en || '' : values?.short_description || '';

    return (
        <section className="cert-award-section">
            <div className="cert-award-content">
                <div className="cert-award-text">
                    <h2 className="cert-award-title">
                        {firstTwo} {rest && <span>{rest}</span>}
                    </h2>
                    <p className="cert-award-desc">{description}</p>
                </div>

                <div className="cert-award-images" ref={scrollRef}>
                    {items.map((item, index) => (
                        <div key={index} className="cert-card">
                            <img src={item.image_url} alt={`cert-${index}`} />
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default CertAwardSection;
